import { setDocumentsBatch as apiSetDocumentsBatch } from './api-client';

export async function setDocumentsBatch(records, maxRecords = '1000000') {
  try {
    const result = await apiSetDocumentsBatch(records, maxRecords);
    console.log("Batch insert successful:", result);
    return result;
  } catch (error) {
    console.error("Error saving batch:", error);
    throw error;
  }
}